import { render, staticRenderFns } from "./CommentsBlock.vue?vue&type=template&id=e08ea46c&scoped=true"
import script from "./CommentsBlock.vue?vue&type=script&lang=js"
export * from "./CommentsBlock.vue?vue&type=script&lang=js"
import style0 from "./CommentsBlock.vue?vue&type=style&index=0&id=e08ea46c&prod&scoped=true&lang=scss"
import style1 from "./CommentsBlock.vue?vue&type=style&index=1&id=e08ea46c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08ea46c",
  null
  
)

export default component.exports